"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayFromOption = exports.listFromOption = exports.fromOption = exports.onSome = exports.mapO = exports.some = exports.none = void 0;
var immutable_1 = require("immutable");
var sum_1 = require("./sum");
var none = function () { return (0, sum_1.inl)({}); };
exports.none = none;
var some = function (v) { return (0, sum_1.inr)(v); };
exports.some = some;
var mapO = function (f, o) { return o.kind == "r" ? (0, exports.some)(f(o.v)) : (0, exports.none)(); };
exports.mapO = mapO;
exports.onSome = exports.mapO;
var fromOption = function (def, o) {
    return o.kind == "r" ? o.v : def;
};
exports.fromOption = fromOption;
var listFromOption = function (x) { return x.kind == "l" ? (0, immutable_1.List)() : (0, immutable_1.List)().push(x.v); };
exports.listFromOption = listFromOption;
var arrayFromOption = function (x) { return x.kind == "l" ? [] : [x.v]; };
exports.arrayFromOption = arrayFromOption;
